import React, { FC, SVGProps } from 'react';
import styled from 'styled-components';
import theme from 'themes';

const Svg = styled.svg.attrs(({ width }) => ({
  width: width || '18px',
  height: width,
  fill: 'none'
}))``;

type IconProps = {
  width?: string;
  fill?: string;
};
const primaryBlue = theme.colors.primaryBlue5;
export const UserGuidesIcon = ({
  width = '22',
  color
}: {
  width?: string;
  color?: string;
}): JSX.Element => {
  return (
    <Svg width={width} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/Svg">
      <g id="Frame" clipPath="url(#clip0_5974_115425)">
        <path
          id="Vector"
          d="M13.3335 11.6667C13.3335 13.4348 14.0359 15.1305 15.2861 16.3807C16.5364 17.631 18.2321 18.3333 20.0002 18.3333C21.7683 18.3333 23.464 17.631 24.7142 16.3807C25.9645 15.1305 26.6668 13.4348 26.6668 11.6667C26.6668 9.89856 25.9645 8.20286 24.7142 6.95262C23.464 5.70238 21.7683 5 20.0002 5C18.2321 5 16.5364 5.70238 15.2861 6.95262C14.0359 8.20286 13.3335 9.89856 13.3335 11.6667Z"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M10 35V31.6667C10 29.8986 10.7024 28.2029 11.9526 26.9526C13.2029 25.7024 14.8986 25 16.6667 25H20.8333"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M28.335 31.6673C28.335 32.5514 28.6862 33.3992 29.3113 34.0243C29.9364 34.6495 30.7842 35.0007 31.6683 35.0007C32.5523 35.0007 33.4002 34.6495 34.0253 34.0243C34.6504 33.3992 35.0016 32.5514 35.0016 31.6673C35.0016 30.7833 34.6504 29.9354 34.0253 29.3103C33.4002 28.6852 32.5523 28.334 31.6683 28.334C30.7842 28.334 29.9364 28.6852 29.3113 29.3103C28.6862 29.9354 28.335 30.7833 28.335 31.6673Z"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M31.6685 25.834V28.334"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M31.6685 35V37.5"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M36.7202 28.75L34.5552 30"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_7"
          d="M28.7834 33.334L26.6167 34.584"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_8"
          d="M26.6167 28.75L28.7834 30"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_9"
          d="M34.5552 33.334L36.7218 34.584"
          stroke={color || primaryBlue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5974_115425">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export const AdminIcons = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <Svg
      width={width}
      height={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4227)">
        <path
          id="Vector"
          d="M2.24097 8C2.24097 8.78793 2.39616 9.56815 2.69769 10.2961C2.99922 11.0241 3.44117 11.6855 3.99833 12.2426C4.55548 12.7998 5.21691 13.2417 5.94487 13.5433C6.67282 13.8448 7.45304 14 8.24097 14C9.0289 14 9.80911 13.8448 10.5371 13.5433C11.265 13.2417 11.9265 12.7998 12.4836 12.2426C13.0408 11.6855 13.4827 11.0241 13.7842 10.2961C14.0858 9.56815 14.241 8.78793 14.241 8C14.241 7.21207 14.0858 6.43185 13.7842 5.7039C13.4827 4.97595 13.0408 4.31451 12.4836 3.75736C11.9265 3.20021 11.265 2.75825 10.5371 2.45672C9.80911 2.15519 9.0289 2 8.24097 2C7.45304 2 6.67282 2.15519 5.94487 2.45672C5.21691 2.75825 4.55548 3.20021 3.99833 3.75736C3.44117 4.31451 2.99922 4.97595 2.69769 5.7039C2.39616 6.43185 2.24097 7.21207 2.24097 8Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.24097 6.6665C6.24097 7.19694 6.45168 7.70565 6.82675 8.08072C7.20183 8.45579 7.71053 8.6665 8.24097 8.6665C8.7714 8.6665 9.28011 8.45579 9.65518 8.08072C10.0303 7.70565 10.241 7.19694 10.241 6.6665C10.241 6.13607 10.0303 5.62736 9.65518 5.25229C9.28011 4.87722 8.7714 4.6665 8.24097 4.6665C7.71053 4.6665 7.20183 4.87722 6.82675 5.25229C6.45168 5.62736 6.24097 6.13607 6.24097 6.6665Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M4.35303 12.5658C4.51803 12.0167 4.85567 11.5353 5.31586 11.1932C5.77604 10.851 6.33426 10.6663 6.90769 10.6665H9.57436C10.1485 10.6663 10.7074 10.8514 11.168 11.1944C11.6285 11.5373 11.966 12.0197 12.1304 12.5698"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4227">
          <rect width="16" height="16" fill="white" transform="translate(0.240967)" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export const BookIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4232)">
        <path
          id="Vector"
          d="M12.9076 2.6665V13.3332H4.90755C4.55393 13.3332 4.21479 13.1927 3.96474 12.9426C3.71469 12.6926 3.57422 12.3535 3.57422 11.9998V3.99984C3.57422 3.64622 3.71469 3.30708 3.96474 3.05703C4.21479 2.80698 4.55393 2.6665 4.90755 2.6665H12.9076Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M12.9076 10.6665H4.90755C4.55393 10.6665 4.21479 10.807 3.96474 11.057C3.71469 11.3071 3.57422 11.6462 3.57422 11.9998"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M6.24097 5.3335H10.241"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4232">
          <rect width="16" height="16" fill="white" transform="translate(0.240967)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FileIcon = ({ width = '22' }: { width?: string }): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4267)">
        <path
          id="Vector"
          d="M9.57422 2V4.66667C9.57422 4.84348 9.64446 5.01305 9.76948 5.13807C9.89451 5.2631 10.0641 5.33333 10.2409 5.33333H12.9076"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M11.5742 14H4.90755C4.55393 14 4.21479 13.8595 3.96474 13.6095C3.71469 13.3594 3.57422 13.0203 3.57422 12.6667V3.33333C3.57422 2.97971 3.71469 2.64057 3.96474 2.39052C4.21479 2.14048 4.55393 2 4.90755 2H9.57422L12.9076 5.33333V12.6667C12.9076 13.0203 12.7671 13.3594 12.517 13.6095C12.267 13.8595 11.9278 14 11.5742 14Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M6.24097 6H6.90763"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M6.24097 8.6665H10.241"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M6.24097 11.3335H10.241"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4267">
          <rect width="16" height="16" fill="white" transform="translate(0.240967)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WarehoueseIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4242)">
        <path
          id="Vector"
          d="M2.24097 13.9998V5.33317L8.24097 2.6665L14.241 5.33317V13.9998"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M8.90771 8.6665H11.5744V13.9998H4.90771V9.99984H8.90771"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M8.90763 14.0002V8.00016C8.90763 7.82335 8.8374 7.65378 8.71237 7.52876C8.58735 7.40373 8.41778 7.3335 8.24097 7.3335H6.90763C6.73082 7.3335 6.56125 7.40373 6.43623 7.52876C6.3112 7.65378 6.24097 7.82335 6.24097 8.00016V10.0002"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4242">
          <rect width="16" height="16" fill="white" transform="translate(0.240967)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SocketIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4237)">
        <path
          id="Vector"
          d="M2.66675 3.99984C2.66675 3.64622 2.80722 3.30708 3.05727 3.05703C3.30732 2.80698 3.64646 2.6665 4.00008 2.6665H12.0001C12.3537 2.6665 12.6928 2.80698 12.9429 3.05703C13.1929 3.30708 13.3334 3.64622 13.3334 3.99984V11.9998C13.3334 12.3535 13.1929 12.6926 12.9429 12.9426C12.6928 13.1927 12.3537 13.3332 12.0001 13.3332H4.00008C3.64646 13.3332 3.30732 13.1927 3.05727 12.9426C2.80722 12.6926 2.66675 12.3535 2.66675 11.9998V3.99984Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M6.00008 8.33317C6.18418 8.33317 6.33341 8.18393 6.33341 7.99984C6.33341 7.81574 6.18418 7.6665 6.00008 7.6665C5.81599 7.6665 5.66675 7.81574 5.66675 7.99984C5.66675 8.18393 5.81599 8.33317 6.00008 8.33317Z"
          fill="#0076CC"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.0001 8.33317C10.1842 8.33317 10.3334 8.18393 10.3334 7.99984C10.3334 7.81574 10.1842 7.6665 10.0001 7.6665C9.81599 7.6665 9.66675 7.81574 9.66675 7.99984C9.66675 8.18393 9.81599 8.33317 10.0001 8.33317Z"
          fill="#0076CC"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4237">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WrinchIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4247)">
        <path
          id="Vector"
          d="M4.66673 6.66673H6.66673V4.66673L4.3334 2.3334C5.07982 1.97691 5.9184 1.8606 6.73366 2.00048C7.54893 2.14036 8.30078 2.52954 8.88568 3.11445C9.47059 3.69935 9.85977 4.4512 9.99965 5.26647C10.1395 6.08173 10.0232 6.92031 9.66673 7.66673L13.6667 11.6667C13.9319 11.9319 14.0809 12.2917 14.0809 12.6667C14.0809 13.0418 13.9319 13.4015 13.6667 13.6667C13.4015 13.9319 13.0418 14.0809 12.6667 14.0809C12.2917 14.0809 11.9319 13.9319 11.6667 13.6667L7.66673 9.66673C6.92031 10.0232 6.08173 10.1395 5.26647 9.99965C4.4512 9.85977 3.69935 9.47059 3.11445 8.88568C2.52954 8.30078 2.14036 7.54893 2.00048 6.73366C1.8606 5.9184 1.97691 5.07982 2.3334 4.3334L4.66673 6.66673Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4247">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ToolsIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4250)">
        <path
          id="Vector"
          d="M2.24097 13.9999H4.90763L13.5743 5.33321C13.9279 4.97959 14.1266 4.49997 14.1266 3.99988C14.1266 3.49978 13.9279 3.02016 13.5743 2.66654C13.2207 2.31292 12.7411 2.11426 12.241 2.11426C11.7409 2.11426 11.2613 2.31292 10.9076 2.66654L2.24097 11.3332V13.9999Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M9.90771 3.6665L12.5744 6.33317"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M8.24097 5.33333L4.90763 2L2.24097 4.66667L5.5743 8"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M4.90771 5.3335L3.90771 6.3335"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_5"
          d="M10.9076 8L14.241 11.3333L11.5743 14L8.24097 10.6667"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_6"
          d="M10.9077 11.3335L9.90771 12.3335"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4250">
          <rect width="16" height="16" fill="white" transform="translate(0.240967)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PneumaticIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4263)">
        <path
          id="Vector"
          d="M2 14L14 2"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M2.66675 8.00033C2.66675 9.41481 3.22865 10.7714 4.22885 11.7716C5.22904 12.7718 6.58559 13.3337 8.00008 13.3337C9.41457 13.3337 10.7711 12.7718 11.7713 11.7716C12.7715 10.7714 13.3334 9.41481 13.3334 8.00033C13.3334 6.58584 12.7715 5.22928 11.7713 4.22909C10.7711 3.2289 9.41457 2.66699 8.00008 2.66699C6.58559 2.66699 5.22904 3.2289 4.22885 4.22909C3.22865 5.22928 2.66675 6.58584 2.66675 8.00033Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4263">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const MiscIcon = ({ width = '22' }: IconProps): JSX.Element => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame" clipPath="url(#clip0_6841_4274)">
        <path
          id="Vector"
          d="M2.66675 11.9997V8.66634L5.33341 7.33301L8.00008 8.66634V11.9997L5.33341 13.333L2.66675 11.9997Z"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M5.33325 7.33366V4.00033L7.99992 2.66699L10.6666 4.00033V7.33366"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M8 8.66634L10.6667 7.33301L13.3333 8.66634V11.9997L10.6667 13.333L8 11.9997"
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6841_4274">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BookmarkIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width={'22'}
      height={'22'}
      viewBox="0 0 17 16"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Bookmark">
        <path
          id="Icon"
          d="M4.08325 3.33333C4.08325 2.59695 4.68021 2 5.41659 2H12.0833C12.8196 2 13.4166 2.59695 13.4166 3.33333V14L8.74992 11.6667L4.08325 14V3.33333Z"
          fill={props.fill || primaryBlue}
          stroke="#0076CC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export const MachineIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M1.99995 4.8125C1.70974 4.8125 1.47363 5.04255 1.47363 5.32532C1.47363 5.60809 1.70974 5.83814 1.99995 5.83814C2.29016 5.83814 2.52626 5.60809 2.52626 5.32532C2.52626 5.04255 2.29016 4.8125 1.99995 4.8125Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_2"
        d="M1.99995 3.38477C1.70974 3.38477 1.47363 3.61482 1.47363 3.89759C1.47363 4.18036 1.70974 4.41041 1.99995 4.41041C2.29016 4.41041 2.52626 4.18036 2.52626 3.89759C2.52626 3.61482 2.29016 3.38477 1.99995 3.38477Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_3"
        d="M12.8305 6.45312H12.83C12.612 6.45312 12.4355 6.62528 12.4355 6.83774C12.4355 7.0502 12.6125 7.22236 12.8305 7.22236C13.0486 7.22236 13.2253 7.0502 13.2253 6.83774C13.2253 6.62528 13.0486 6.45312 12.8305 6.45312Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_4"
        d="M8.13047 0.846154V0.384615C8.13047 0.172154 7.95379 0 7.73574 0H5.99889C5.78084 0 5.60416 0.172154 5.60416 0.384615V2.82928H4.07558V2.07692C4.07558 1.86446 3.89889 1.69231 3.68084 1.69231H0.394737C0.176684 1.69231 0 1.86446 0 2.07692V13.9231C0 14.1355 0.176684 14.3077 0.394737 14.3077H1.10711C0.958105 14.4864 0.868421 14.7138 0.868421 14.9614C0.868421 15.5341 1.34658 16 1.93432 16C2.52211 16 3.00026 15.5341 3.00026 14.9614C3.00026 14.7138 2.91058 14.4864 2.76158 14.3077H13.265C13.116 14.4864 13.0263 14.7138 13.0263 14.9614C13.0263 15.5341 13.5045 16 14.0922 16C14.68 16 15.1582 15.5341 15.1582 14.9614C15.1582 14.7138 15.0685 14.4864 14.9195 14.3077H15.6053C15.8233 14.3077 16 14.1355 16 13.9231V5.27041C16 5.05795 15.8233 4.8858 15.6053 4.8858H15.5526V2.92308C15.5526 2.71062 15.3759 2.53846 15.1579 2.53846H13.4211C13.203 2.53846 13.0263 2.71062 13.0263 2.92308V3.38462H12.9868C12.4862 3.38462 12.0789 2.98779 12.0789 2.5C12.0789 1.5881 11.3175 0.846154 10.3816 0.846154H8.13047ZM1.93432 15.2308C1.78189 15.2308 1.65789 15.1099 1.65789 14.9614C1.65789 14.8129 1.78189 14.6921 1.93432 14.6921C2.08674 14.6921 2.21079 14.8129 2.21079 14.9614C2.21079 15.1099 2.08674 15.2308 1.93432 15.2308ZM14.0922 15.2308C13.9398 15.2308 13.8158 15.1099 13.8158 14.9614C13.8158 14.8129 13.9398 14.6921 14.0922 14.6921C14.2446 14.6921 14.3687 14.8129 14.3687 14.9614C14.3687 15.1099 14.2446 15.2308 14.0922 15.2308ZM4.07558 4.87179H4.47368V5.46154C4.47368 5.60318 4.59147 5.71795 4.73684 5.71795H9.07895C9.22432 5.71795 9.3421 5.60318 9.3421 5.46154V4.87179H9.65905V7.96805H4.07558V4.87179ZM6.71074 4.15385H7.05284V5.20513H6.71074V4.15385ZM10.4485 7.96805V5.65503H15.2105V7.96805H10.4485ZM13.8158 3.30769H14.7632V4.8858H13.8158V3.30769ZM8.13047 1.61538H10.3816C10.8822 1.61538 11.2895 2.01221 11.2895 2.5C11.2895 3.4119 12.0509 4.15385 12.9868 4.15385H13.0263V4.8858H10.4485V3.2139C10.4485 3.00144 10.2718 2.82928 10.0538 2.82928H8.13042V1.61538H8.13047ZM8.13047 3.76923V3.59851H9.65911V4.35897H9.07895C8.93358 4.35897 8.81579 4.47374 8.81579 4.61538V5.20513H7.57916V4.15385H7.73568C7.95374 4.15385 8.13047 3.98169 8.13047 3.76923ZM6.39363 0.769231H7.341V3.38462H6.39363V0.769231ZM5.60416 3.59851V3.76923C5.60416 3.98169 5.78084 4.15385 5.99889 4.15385H6.18447V5.20513H5V4.61538C5 4.47374 4.88221 4.35897 4.73684 4.35897H4.07558V3.59851H5.60416ZM3.28611 13.5385H0.789474V2.46154H3.28611V13.5385ZM4.07558 8.79144H9.65911V13.5385H4.07558V8.79144ZM10.4485 13.5385V8.79144H15.2105V13.5385H10.4485Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_5"
        d="M9.0789 6.89648H4.73679C4.59142 6.89648 4.47363 7.01125 4.47363 7.15289C4.47363 7.29454 4.59142 7.40931 4.73679 7.40931H9.0789C9.22426 7.40931 9.34205 7.29454 9.34205 7.15289C9.34205 7.01125 9.22426 6.89648 9.0789 6.89648Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_6"
        d="M8.21071 11.9746H5.60544C5.46007 11.9746 5.34229 12.0894 5.34229 12.231C5.34229 12.3727 5.46007 12.4874 5.60544 12.4874H8.21071C8.35607 12.4874 8.47386 12.3727 8.47386 12.231C8.47386 12.0894 8.35607 11.9746 8.21071 11.9746Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_7"
        d="M8.21071 11.1289H5.60544C5.46007 11.1289 5.34229 11.2437 5.34229 11.3853C5.34229 11.527 5.46007 11.6417 5.60544 11.6417H8.21071C8.35607 11.6417 8.47386 11.527 8.47386 11.3853C8.47386 11.2437 8.35607 11.1289 8.21071 11.1289Z"
        fill={primaryBlue}
      />
      <path
        id="Vector_8"
        d="M6.86814 10.0778C7.0862 10.0778 7.26288 9.90567 7.26288 9.69321C7.26288 9.48075 7.0862 9.30859 6.86814 9.30859H6.86762C6.64962 9.30859 6.47314 9.48075 6.47314 9.69321C6.47314 9.90567 6.65014 10.0778 6.86814 10.0778Z"
        fill={primaryBlue}
      />
    </g>
  </svg>
);

const docIcons = {
  how_to_user_guide: UserGuidesIcon,
  admin_portal_user_guide: AdminIcons,
  operation_and_maintenance_manual: BookIcon,
  parts_and_service_manual: FileIcon,
  spare_parts_diagram: WarehoueseIcon,
  electrical_schematics: SocketIcon,
  equipment_installation: WrinchIcon,
  supplementary_material: ToolsIcon,
  global_machine_document: BookIcon,
  pneumatic_schematics: PneumaticIcon,
  misc: MiscIcon
};

export type DocCategoryType = keyof typeof docIcons;

export const getDocIcons = (key: DocCategoryType): React.FC<{ width?: string; color?: string }> => {
  const icon = docIcons[key];
  return icon;
};
